export default {
  data () {
    return {
      groupsWithSelected: null,
    }
  },

  computed: {
    onlySelectedGroups: function() {
      return this.groupsWithSelected ? this.groupsWithSelected.filter((group) => !!group.display_names) : null
    },
  },
}